import { localization } from "../localizationManager";

export var dutchStrings = {
  groupButton: "Groep door mij",
  ungroupButton: "Degroeperen bij mij",
  selectButton: "Selecteer mij",
  hideColumn: "Kolom verbergen",
  showColumn: "Toon kolom",
  makePrivateColumn: "Kolom privé maken",
  makePublicColumn: "Maak de kolom openbaar",
  moveToDetail: "Ga naar Detail",
  showAsColumn: "Weergeven als kolom",
  filterPlaceholder: "Zoeken...",
  removeRows: "Verwijder rijen",
  showLabel: "Tonen",
  entriesLabel: "inzendingen",
  visualizer_text: "Teksten in tabel",
  visualizer_wordcloud: "Wordcloud",
  visualizer_histogram: "Histogram",
  visualizer_number: "Gemiddeld",
  visualizer_choices: "Tafel",
  visualizer_selectBase: "Zeekaart",
  chartType_bar: "Bar",
  chartType_vbar: "Verticale balk",
  chartType_stackedbar: "Gestapelde Bar",
  chartType_doughnut: "Donut",
  chartType_pie: "Taart",
  chartType_scatter: "Verstrooien",
  chartType_gauge: "Meter",
  chartType_bullet: "Kogel",
  hideButton: "Verbergen",
  makePrivateButton: "Maak prive",
  makePublicButton: "Openbaar maken",
  showButton: "Tonen",
  filter: "Filter",
  resetFilter: "Filter resetten",
  changeLocale: "Wijzig de landinstelling",
  clearButton: "Doorzichtig",
  addElement: "Kies een vraag om weer te geven ...",
  defaultOrder: "Standaardvolgorde",
  ascOrder: "Oplopend",
  descOrder: "Aflopend",
  showMinorColumns: "Toon kleine kolommen",
  otherCommentTitle: "Andere items en opmerkingen",
  showPercentages: "Percentages weergeven",
  hidePercentages: "Verberg percentages",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Download plot als een png",
  hideEmptyAnswers: "Verberg lege antwoorden",
  showEmptyAnswers: "Toon lege antwoorden",
  "topNValueText-1": "Alle antwoorden",
  topNValueText5: "Top 5 antwoorden",
  topNValueText10: "Top 10 antwoorden",
  topNValueText20: "Top 20 antwoorden",
  hideMissingAnswers: "Ontbrekende antwoorden verbergen",
  showMissingAnswers: "Ontbrekende antwoorden weergeven",
  missingAnswersLabel: "Ontbrekende antwoorden",
  noVisualizerForQuestion: "Dit vraagtype is nog niet gevisualiseerd",
  noResults: "Er zijn nog geen resultaten",
  showPerValues: "Per waarden",
  showPerColumns: "Per Kolommen",
  answer: "Antwoorden",
  correctAnswer: "Goed antwoord: ",
  percent: "Procent",
  responses: "Reacties"
};

//Uncomment these two lines on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
localization.locales["nl"] = dutchStrings;
localization.localeNames["nl"] = "Nederlands";

// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// undefined.visualizer_histogram: "Histogram" => "Histogram"
// undefined.visualizer_number: "Average" => "Gemiddeld"
// undefined.visualizer_choices: "Table" => "Tafel"
// undefined.visualizer_selectBase: "Chart" => "Zeekaart"
// undefined.chartType_vbar: "Vertical Bar" => "Verticale balk"
// undefined.filter: "Filter" => "Filter"
// undefined.hideMissingAnswers: "Hide missing answers" => "Ontbrekende antwoorden verbergen"
// undefined.showMissingAnswers: "Show missing answers" => "Ontbrekende antwoorden weergeven"
// undefined.missingAnswersLabel: "Missing answers" => "Ontbrekende antwoorden"
// undefined.noVisualizerForQuestion: "This question type is not visualized yet" => "Dit vraagtype is nog niet gevisualiseerd"
// undefined.noResults: "There are no results yet" => "Er zijn nog geen resultaten"
// undefined.showPerValues: "Per Values" => "Per waarden"
// undefined.showPerColumns: "Per Columns" => "Per Kolommen"
// undefined.answer: "Answer" => "Antwoorden"
// undefined.correctAnswer: "Correct answer: " => "Goed antwoord: "
// undefined.percent: "Percent" => "Procent"
// undefined.responses: "Responses" => "Reacties"